var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQArrowDown = function SvgQArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1374",
    d: "M9.414 6.586a2 2 0 0 1-2.828 0L0 0h16z"
  })));
};
export { SvgQArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE2IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGlkPSJhcnJvdyIgZD0iTTkuNDE0MjEgNi41ODU3OUM4LjYzMzE2IDcuMzY2ODQgNy4zNjY4MyA3LjM2NjgzIDYuNTg1NzggNi41ODU3OUwwIDBMMTYgMEw5LjQxNDIxIDYuNTg1NzlaIiBmaWxsPSIjMUMxMzc0Ii8+Cjwvc3ZnPgo=";